import { Component, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import { OopsCategory } from "src/app/core/components/categories";
import { PAGE_TITLE } from "../../settings-management-content/shared/title-constant";
import { ACTION_STATUS, ActionBarHandlerModel, ActionbarService } from "src/app/shared/ui/actionbar";
import { RefreshButtonModel } from "src/app/shared/ui/actionbar/models";
import { combineLatest, Subscription } from "rxjs";
import { SecurityGroupSecurityModel } from "src/app/core/models/security-model/security-group-security.model";
import { DateConverterService } from "src/app/core/utils/date-converter.service";
import { FormOfPaymentIssuerContextMenu, FormOfPaymentTypeContextMenu, NewActionId, PaymentAcquirerContextMenu, SearchActionId, SortActionId } from "./payment-definition-context-menu";
import { SecurityGroupService } from "src/app/core/services/system-services/security-group.service";
import { LogCommitService } from "src/app/core/services/system-services";
import { LoadingSpinnerService } from "src/app/shared/layout/loading-spinner";
import { AlertBarService } from "src/app/shared/layout/alertbar";
import { Router } from "@angular/router";
import { LogCommitModel } from "src/app/core/models/log-commit-model/log-commit.model";
import { FormOfPayment, FormOfPaymentIssuer, FormOfPaymentIssuerSecurityCode, FormOfPaymentType, FormOfPaymentTypeSecurityCode, PaymentAcquirer, PaymentAcquirerSecurityCode, PaymentDefinitions, PaymentDefinitionSecurityCodes, PaymentMerchant } from "./payment-definition-categories";
import { NavigationService } from "src/app/shared/utils/navigation";
import { FormOfPaymentTypeSearchService } from ".";
import { FormOfPaymentTypeSortService } from "./form-of-payment-type-sort/form-of-payment-type-sort.service";
import { FormOfPaymentSortService } from "./form-of-payment-sort/form-of-payment-sort.service";
import { FormOfPaymentTypeSearch } from "src/app/core/models/form-of-payment-model";
import { FormOfPaymentIssuerSearchService } from "./form-of-payment-issuer/search/form-of-payment-issuer-search.service";
import { FormOfPaymentIssuerSortService } from "./form-of-payment-issuer-sort/form-of-payment-issuer-sort.service";
import { PaymentAcquirerSearchService } from "./payment-acquirer/search/payment-acquirer-search.service";
import { PaymentMerchantSortService } from "./payment-merchant-sort/payment-merchant-sort.service";
import { PaymentAcquirerSearch } from "src/app/core/models/payment-acquirer-model";
import { PaymentAcquirerSortService } from "./payment-acquirer-sort/payment-acquirer-sort.service";

@Component({
    selector: 'op-payment-definition',
    templateUrl: './payment-definition.component.html',
    providers: [ActionbarService]
})
export class PaymentDefinitionComponent implements OnInit, OnDestroy, AfterViewInit {

    actionBarHandler = new ActionBarHandlerModel(
        new RefreshButtonModel(),
    )

    searchComponentVisibility: Map<string, boolean>
    sortComponentVisibility: Map<string, boolean>

    securities: SecurityGroupSecurityModel[]

    private subscriptions: Subscription[]
    private formOfPaymentTypeCode: string;
    private formOfPaymentTypeName: string;
    private dataSource: FormOfPaymentTypeSearch[]
    private currentPageIndex: number;

    private paymentAcquirerCode: string;
    private paymentAcquirerName: string;
    private paymentAcquirerDataSource: PaymentAcquirerSearch[]
    private paymentAcquirerCurrentPageIndex: number;

    constructor(private actionbarService: ActionbarService,
        private dateConverterService: DateConverterService,
        private securityGroupService: SecurityGroupService,
        private loadingSpinnerService: LoadingSpinnerService,
        private cdr: ChangeDetectorRef,
        public alertBarService: AlertBarService,
        private router: Router,
        private logCommitService: LogCommitService,
        private navigationService: NavigationService,
        private formOfPaymentTypeSearchService: FormOfPaymentTypeSearchService,
        private formOfPaymentTypeSortService: FormOfPaymentTypeSortService,
        private formOfPaymentSortService: FormOfPaymentSortService,
        private formOfPaymentIssuerSearchService: FormOfPaymentIssuerSearchService,
        private formOfPaymentIssuerSortService: FormOfPaymentIssuerSortService,
        private paymentAcquirerSearchService: PaymentAcquirerSearchService,
        private paymentAcquirerSortService: PaymentAcquirerSortService,
        private paymentMerchantSortService: PaymentMerchantSortService
    ) { }

    private fetchPaymentDefinitionInfos() {
        this.loadingSpinnerService.show()
        combineLatest([
            this.securityGroupService.userSecurityGroupSecurity,
            this.logCommitService.getByCode(FormOfPaymentTypeSecurityCode),
            this.logCommitService.getByCode(FormOfPaymentIssuerSecurityCode),
            this.logCommitService.getByCode(PaymentAcquirerSecurityCode)
        ])
            .subscribe(
                ([
                    userSecurityModels,
                    logCommitFormOfPaymentType,
                    logCommitFormOfPaymentIssuer,
                    logCommitPaymentAcquier
                ]) => {
                    const logCommitMap = new Map<string, LogCommitModel>()
                    logCommitMap.set(FormOfPaymentTypeSecurityCode, logCommitFormOfPaymentType)
                    logCommitMap.set(FormOfPaymentIssuerSecurityCode, logCommitFormOfPaymentIssuer)
                    logCommitMap.set(PaymentAcquirerSecurityCode, logCommitPaymentAcquier)
                    this.securities = userSecurityModels
                    this.groupCategoryItems = this.getCategories(logCommitMap, userSecurityModels)
                    if (this.categoryItemName) {
                        this.groupCategorySelected(this.groupCategoryItems.find(g => g.name == this.categoryItemName))
                    }
                    else {
                        this.groupCategorySelected(this.groupCategoryItems[0])
                    }

                    this.loadingSpinnerService.hide();
                    this.cdr.markForCheck();
                },
                error => {
                    this.loadingSpinnerService.hide();
                }
            );
    }

    private getCategories(commitInfos: Map<string, LogCommitModel>, userSecurities: SecurityGroupSecurityModel[]): OopsCategory[] {
        const categories = []
        for (let category of [...PaymentDefinitions]) {
            const moduleName = category.name
            const commitInfo = commitInfos.get(PaymentDefinitionSecurityCodes.get(moduleName));
            if (PaymentDefinitionSecurityCodes.has(moduleName)) {
                const userSec = userSecurities?.find(s => s.securityCode == PaymentDefinitionSecurityCodes.get(moduleName))
                if (userSec) {
                    this.mergeCategoryInfo(category, commitInfo, userSec, moduleName)
                    categories.push(category)
                }
            }
            else {
                this.mergeCategoryInfo(category, commitInfo, null, moduleName)
                categories.push(category)
            }
        }
        return categories
    }


    private mergeCategoryInfo(category: OopsCategory, commitInfos: LogCommitModel, userSecurity: SecurityGroupSecurityModel, moduleName: string): void {
        category.modifiedBy = commitInfos?.commitByName
        category.modifiedDateTime = this.dateConverterService.convertDateTime24(commitInfos?.commitDateTime)
        category.security = userSecurity
        this.setContextMenus(category, moduleName)
        this.setSecurityContextMenus(category)
    }

    private setContextMenus(category: OopsCategory, moduleName: string) {
        switch (moduleName) {
            case FormOfPaymentType:
                category.contextMenus = FormOfPaymentTypeContextMenu
                break
            case FormOfPaymentIssuer:
                category.contextMenus = FormOfPaymentIssuerContextMenu
                break
            case PaymentAcquirer:
                category.contextMenus = PaymentAcquirerContextMenu
                break
        }
    }

    private setSecurityContextMenus(category: OopsCategory) {
        if (category.security) {
            const newActionMenu = category.contextMenus.find(item => item.actionId == NewActionId)
            if (newActionMenu) {
                newActionMenu.disable = category.security.newFlag == false
            }
            const sortActionMenu = category.contextMenus.find(item => item.actionId == SortActionId)
            if (sortActionMenu) {
                sortActionMenu.disable = category.security.editFlag == false
            }
        }
    }

    readonly GroupTabId = 'GROUP'
    readonly SearchTabId = 'SEARCH'
    readonly SortTabId = 'SORT'

    title: string
    navActiveId: string
    categoryItemName: string

    ngOnInit(): void {
        this.subscriptions = []
        this.groupCategoryItems = []

        const currentTabId = this.router.url.split('/')[3]
        const key = '_detail_page_' + currentTabId
        let params: any = localStorage.getItem(key)

        if (params) {
            params = JSON.parse(params)
            localStorage.removeItem(key)
        }
        else {
            params = this.navigationService.getParams();
        }

        if (params?.navActiveId && currentTabId == params?.fromTabId) {
            this.categoryItemName = params?.categoryName
            this.navActiveIdChange(params.navActiveId)
        }
        this.setSearchComponentVisibility(FormOfPaymentType);
        if (params?.formOfPaymentTypeCode) {
            this.setFormOfPaymentType(params);
            this.routeSortActionByModuleName();
        } else if (params?.paymentAcquirerCode) {
            this.setPaymentAcquirer(params);
            this.routeSortActionByModuleName();
        } else {
            this.setSortComponentVisibility(PaymentAcquirer);
        }

        this.fetchPaymentDefinitionInfos();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }

    ngAfterViewInit(): void {
        this.setupActionBar()
        this.setupActionBarHandler()
        this.cdr.markForCheck()
    }

    private setupActionBarHandler() {
        this.subscriptions.push(
            this.actionbarService.action$.subscribe(actionId => {
                switch (this.navActiveId) {
                    case this.GroupTabId:
                        switch (actionId) {
                            case ACTION_STATUS.refresh:
                                this.fetchPaymentDefinitionInfos();
                                break;
                            case ACTION_STATUS.back:
                                this.navigationService.navigate('main/settings', PAGE_TITLE.settings);
                                break;
                        }
                        break
                    case this.SearchTabId:
                        if (this.categoryItemName == FormOfPaymentType) {
                            switch (actionId) {
                                case ACTION_STATUS.back:
                                case ACTION_STATUS.cancel:
                                    this.navActiveIdChange(this.GroupTabId)
                                    break;
                                case ACTION_STATUS.refresh:
                                    this.formOfPaymentTypeSearchService.refresh()
                                    break;
                                case ACTION_STATUS.new:
                                    this.navigationService.navigate(`/main/settings/form-of-payment-type-detail`, null, false, { id: null })
                            }
                        } else if (this.categoryItemName == FormOfPaymentIssuer) {
                            switch (actionId) {
                                case ACTION_STATUS.back:
                                case ACTION_STATUS.cancel:
                                    this.navActiveIdChange(this.GroupTabId)
                                    break;
                                case ACTION_STATUS.refresh:
                                    this.formOfPaymentIssuerSearchService.refresh()
                                    break;
                                case ACTION_STATUS.new:
                                    this.navigationService.navigate(`/main/settings/form-of-payment-issuer-detail`, null, false, { id: null })
                            }
                        } else if (this.categoryItemName == PaymentAcquirer) {
                            switch (actionId) {
                                case ACTION_STATUS.back:
                                case ACTION_STATUS.cancel:
                                    this.navActiveIdChange(this.GroupTabId)
                                    break;
                                case ACTION_STATUS.refresh:
                                    this.paymentAcquirerSearchService.refresh()
                                    break;
                                case ACTION_STATUS.new:
                                    this.navigationService.navigate(`/main/settings/payment-acquirer-detail`, null, false, { id: null })
                            }
                        }
                    case this.SortTabId:
                        if (this.categoryItemName == FormOfPaymentType) {
                            switch (actionId) {
                                case ACTION_STATUS.back:
                                case ACTION_STATUS.cancel:
                                    this.navActiveIdChange(this.GroupTabId)
                                    break
                                case ACTION_STATUS.refresh:
                                    this.formOfPaymentTypeSortService.refresh()
                                    break
                                case ACTION_STATUS.save:
                                    this.formOfPaymentTypeSortService.updateSort()
                                    break
                            }
                        }
                        else if (this.categoryItemName == FormOfPayment) {
                            switch (actionId) {
                                case ACTION_STATUS.back:
                                    this.gotoFormOfPaymentDetail();
                                    break
                                case ACTION_STATUS.cancel:
                                    this.navActiveIdChange(this.GroupTabId)
                                    break
                                case ACTION_STATUS.refresh:
                                    this.formOfPaymentSortService.refresh()
                                    break
                                case ACTION_STATUS.save:
                                    this.formOfPaymentSortService.updateSort()
                                    break
                            }
                        } else if (this.categoryItemName == FormOfPaymentIssuer) {
                            switch (actionId) {
                                case ACTION_STATUS.back:
                                case ACTION_STATUS.cancel:
                                    this.navActiveIdChange(this.GroupTabId)
                                    break
                                case ACTION_STATUS.refresh:
                                    this.formOfPaymentIssuerSortService.refresh()
                                    break
                                case ACTION_STATUS.save:
                                    this.formOfPaymentIssuerSortService.updateSort()
                                    break
                            }
                        } else if (this.categoryItemName == PaymentAcquirer) {
                            switch (actionId) {
                                case ACTION_STATUS.back:
                                case ACTION_STATUS.cancel:
                                    this.navActiveIdChange(this.GroupTabId)
                                    break
                                case ACTION_STATUS.refresh:
                                    this.paymentAcquirerSortService.refresh()
                                    break
                                case ACTION_STATUS.save:
                                    this.paymentAcquirerSortService.updateSort()
                                    break
                            }
                        } else if (this.categoryItemName == PaymentMerchant) {
                            switch (actionId) {
                                case ACTION_STATUS.back:
                                    this.gotoPaymentAcquirerDetail();
                                    break
                                case ACTION_STATUS.cancel:
                                    this.navActiveIdChange(this.GroupTabId)
                                    break
                                case ACTION_STATUS.refresh:
                                    this.paymentMerchantSortService.refresh()
                                    break
                                case ACTION_STATUS.save:
                                    this.paymentMerchantSortService.updateSort()
                                    break
                            }
                        }

                        break
                }
            })
        )
    }

    navActiveIdChange(navActiveId: string): void {
        this.navActiveId = navActiveId
        switch (navActiveId) {
            case this.GroupTabId:
                this.setupActionBar()
                this.titleUpdate(PAGE_TITLE.payment)
                break
            case this.SearchTabId:
                this.routeSearchActionByModuleName()
                break
            case this.SortTabId:
                if (this.categoryItemName == FormOfPayment) {
                    this.categoryItemName = FormOfPaymentType;
                    this.setSortComponentVisibility(FormOfPaymentType);
                }
                if (this.categoryItemName == PaymentMerchant) {
                    this.categoryItemName = PaymentAcquirer;
                    this.setSortComponentVisibility(PaymentAcquirer);
                }
                this.routeSortActionByModuleName()
                break
        }
    }

    groupCategoryItems: OopsCategory[]
    selectedCategoryItem: OopsCategory

    groupCategorySelected(categoryItem: OopsCategory): void {
        if (categoryItem) {
            this.selectedCategoryItem = categoryItem
            this.categoryItemName = categoryItem.name

            this.setSearchComponentVisibility(this.selectedCategoryItem.name)
            this.setSortComponentVisibility(this.selectedCategoryItem.name)
        }
    }

    groupCategoryContextMenuSelected(actionId: string): void {
        switch (actionId) {
            case NewActionId:
                this.routeNewActionByModuleName();
                break
            case SearchActionId:
                this.navActiveId = this.SearchTabId
                this.routeSearchActionByModuleName()
                break
            case SortActionId:
                this.navActiveId = this.SortTabId
                this.routeSortActionByModuleName()
                break
        }
    }

    titleUpdate(title: string) {
        this.title = title
    }

    setupActionBar() {
        this.actionbarService.updateState(this.actionBarHandler)
    }

    hideAlertInformation() {
        this.alertBarService.hideInformation()
        this.alertBarService.hide()
    }

    showAlertBarError(tuple: [string, string]) {
        const [panelName, errorMessage] = tuple
        this.alertBarService.show(panelName, errorMessage)
    }

    hideSortTab() {
        return false;
    }

    private setSearchComponentVisibility(key: typeof FormOfPaymentType | typeof FormOfPaymentIssuer | string) {
        this.searchComponentVisibility = new Map()
            .set(FormOfPaymentType, false)
            .set(FormOfPaymentIssuer, false)
            .set(PaymentAcquirer, false)
            .set(FormOfPayment, false)

        if (this.hasSecurity(key)) {
            this.searchComponentVisibility.set(key, true)
        }
    }

    private setSortComponentVisibility(key: typeof FormOfPaymentType | typeof FormOfPaymentIssuer | string) {
        this.sortComponentVisibility = new Map()
            .set(FormOfPaymentType, false)
            .set(FormOfPaymentIssuer, false)
            .set(PaymentAcquirer, false)
            .set(FormOfPayment, false)
            .set(PaymentMerchant, false)

        if (this.hasSecurity(key)) {
            this.sortComponentVisibility.set(key, true)
        }
    }

    private hasSecurity(key: string) {
        let securityCode = null;
        if (FormOfPaymentType == key || FormOfPayment == key) {
            securityCode = FormOfPaymentTypeSecurityCode;
        }
        else if (FormOfPaymentIssuer == key) {
            securityCode = FormOfPaymentIssuerSecurityCode;
        }
        else if (PaymentAcquirer == key || PaymentMerchant == key) {
            securityCode = PaymentAcquirerSecurityCode;
        }
        else {
            throw new Error('security not found')
        }
        return this.securities?.some(s => s.securityCode == securityCode)
    }

    private routeSearchActionByModuleName() {
        if (this.selectedCategoryItem) {
            this.loadByCategoryName(this.selectedCategoryItem.name)
        }
        else if (this.categoryItemName) {
            this.loadByCategoryName(this.categoryItemName)
        }
        else {
            this.categoryItemName = FormOfPaymentType
            this.titleUpdate(PAGE_TITLE.form_of_payment_type)
            this.formOfPaymentTypeSearchService.callSearch()
        }
    }

    private loadByCategoryName(categoryItemName: string) {
        this.categoryItemName = categoryItemName
        switch (categoryItemName) {
            case FormOfPaymentType:
                this.titleUpdate(PAGE_TITLE.form_of_payment_type);
                this.formOfPaymentTypeSearchService.callSearch();
                break;
            case FormOfPayment:
                this.setSearchComponentVisibility(FormOfPaymentType);
                this.titleUpdate(PAGE_TITLE.form_of_payment_type);
                this.formOfPaymentTypeSearchService.callSearch();
                break;
            case FormOfPaymentIssuer:
                this.titleUpdate(PAGE_TITLE.form_of_payment_issuer);
                this.formOfPaymentIssuerSearchService.callSearch();
                break;
            case PaymentAcquirer:
                this.titleUpdate(PAGE_TITLE.payment_acquirer);
                this.paymentAcquirerSearchService.callSearch();
                break;
            case PaymentMerchant:
                this.setSearchComponentVisibility(PaymentAcquirer);
                this.titleUpdate(PAGE_TITLE.payment_acquirer);
                this.paymentAcquirerSearchService.callSearch();
                break;                
        }
    }

    private routeSortActionByModuleName() {
        if (this.selectedCategoryItem) {
            this.categoryItemName = this.selectedCategoryItem.name
            if (this.selectedCategoryItem.name == FormOfPaymentType) {
                this.titleUpdate(PAGE_TITLE.form_of_payment_type)
                this.formOfPaymentTypeSortService.callSort()
            } else if (this.selectedCategoryItem.name == FormOfPaymentIssuer) {
                this.titleUpdate(PAGE_TITLE.form_of_payment_issuer)
                this.formOfPaymentIssuerSortService.callSort()
            }
        }
        else {
            if (this.categoryItemName == FormOfPayment) {
                this.displayFormOfPaymentSort();
            } if (this.categoryItemName == PaymentMerchant) {
                this.displayPaymentMerchantSort();
            } else {
                this.categoryItemName = FormOfPaymentType
                this.titleUpdate(PAGE_TITLE.form_of_payment_type)
                this.formOfPaymentTypeSortService.callSort()
            }
        }
        this.cdr.detectChanges();
    }

    private setFormOfPaymentType(params) {
        this.formOfPaymentTypeCode = params?.formOfPaymentTypeCode;
        this.formOfPaymentTypeName = params?.formOfPaymentTypeName;
        this.dataSource = params?.dataSource;
        this.currentPageIndex = params?.currentPageIndex;
    }

    private setPaymentAcquirer(params) {
        this.paymentAcquirerCode = params?.paymentAcquirerCode;
        this.paymentAcquirerName = params?.paymentAcquirerName;
        this.paymentAcquirerDataSource = params?.dataSource;
        this.paymentAcquirerCurrentPageIndex = params?.currentPageIndex;
    }

    private displayFormOfPaymentSort() {
        setTimeout(() => {
            this.navActiveId = this.SortTabId;
            this.titleUpdate(PAGE_TITLE.form_of_payment_type);
            this.setSortComponentVisibility(FormOfPayment);
            this.formOfPaymentSortService.callSort(this.formOfPaymentTypeCode, this.formOfPaymentTypeName)
            this.cdr.detectChanges();
        }, 500);
    }

    private displayPaymentMerchantSort() {
        setTimeout(() => {
            this.navActiveId = this.SortTabId;
            this.titleUpdate(PAGE_TITLE.payment_acquirer);
            this.setSortComponentVisibility(PaymentMerchant);
            this.paymentMerchantSortService.callSort(this.paymentAcquirerCode, this.paymentAcquirerName)
            this.cdr.detectChanges();
        }, 500);
    }

    private gotoFormOfPaymentDetail() {
        let params = { id: this.formOfPaymentTypeCode, pageData: this.dataSource, currentPageIndex: this.currentPageIndex }
        this.navigationService.navigate(`/main/settings/form-of-payment-type-detail`, null, false, params)
    }

    private routeNewActionByModuleName() {
        if (this.selectedCategoryItem) {
            switch (this.selectedCategoryItem.name) {
                case FormOfPaymentType:
                    this.navigationService.navigate(`/main/settings/form-of-payment-type-detail`, null, false, { id: null });
                    break
                case FormOfPaymentIssuer:
                    this.navigationService.navigate(`/main/settings/form-of-payment-issuer-detail`, null, false, { id: null });
                    break
                case PaymentAcquirer:
                    this.navigationService.navigate(`/main/settings/payment-acquirer-detail`, null, false, { id: null });
                    break
            }
        }
    }

    private gotoPaymentAcquirerDetail() {
        let params = { id: this.paymentAcquirerCode, pageData: this.paymentAcquirerDataSource, currentPageIndex: this.paymentAcquirerCurrentPageIndex }
        this.navigationService.navigate(`/main/settings/payment-acquirer-detail`, null, false, params)
    }
}
